import { DownloadIcon } from "@chakra-ui/icons";
import { Box } from "@chakra-ui/react";
import { FC } from "react";

import { humanizeBytes } from "@nens/shared-utils";

import downloadFromUrl from "../utils/downloadFromUrl";

import InternalLink from "./InternalLink";

interface Props {
  filename: string;
  size: number;
  fetchUrl: () => Promise<string | undefined>;
}

const GenerateAndOpenLink: FC<Props> = ({ filename, size, fetchUrl, ...rest }) => {
  return (
    <Box>
      <InternalLink
        onClick={async (event) => {
          event.preventDefault();
          const url = await fetchUrl();
          if (url) {
            downloadFromUrl(url, filename || "");
          }
        }}
        to={"#"}
        {...rest}
      >
        <DownloadIcon boxSize={6} color="brand.deep_sea" />
        &nbsp;
        {filename}
      </InternalLink>
      &nbsp;({humanizeBytes(size)})
    </Box>
  );
};

export default GenerateAndOpenLink;
